export default __webpack_public_path__ + "static/media/480_dummy2016-naeherin01-de.5c69a5f7.png";